module.exports = __webpack_public_path__ + "static/media/edit.7f511d09.svg";